import { render, staticRenderFns } from "./SignatureAddress.vue?vue&type=template&id=48637264&scoped=true&"
import script from "./SignatureAddress.vue?vue&type=script&lang=js&"
export * from "./SignatureAddress.vue?vue&type=script&lang=js&"
import style0 from "./SignatureAddress.vue?vue&type=style&index=0&id=48637264&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48637264",
  null
  
)

export default component.exports